import Vue from 'vue'
import { resolve } from 'vue-carousel-3d'
import Router from 'vue-router'
import Message from '../components/message/index' //弹窗
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const router = new Router({
    mode: 'history',
    // linkActiveClass: 'tabbar_active',
    base: '/main/',
    routes: [{
            path: '/login',
            name: 'Login',
            meta: {
                title: '极致了 - 用户登入'
            },
            component: resolve => {
                require(['@/pages/login/login.vue'], resolve)
            }
    },
      // 广告投放
      {
        path: '/advertisingHome',
        name: 'advertisingHome',
        meta: {
          title: '广告投放首页'
        },
        component: resolve => {
          require(['@/pages/advertisingHome.vue'], resolve)
        }
      },
      //广告投放舆情
      {
        path: '/advertisingOpinion',
        name: 'advertisingOpinion',
        meta: {
          title: '广告投放舆情'
        },
        component: resolve => {
          require(['@/pages/advertisingOpinion.vue'], resolve)
        }
      },
      //广告投放seo
      {
        path: '/advertisingSeo',
        name: 'advertisingSeo',
        meta: {
          title: '广告投放seo'
        },
        component: resolve => {
          require(['@/pages/advertisingSeo.vue'], resolve)
        }
      },
      //广告投放大学生
      {
        path: '/undergraduate',
        name: 'undergraduate',
        meta: {
          title: '广告投放大学生'
        },
        component: resolve => {
          require(['@/pages/a_undergraduate.vue'], resolve)
        }
      },

      //广告投放种草带货
      {
        path: '/grassCargo',
        name: 'grassCargo',
        meta: {
          title: '广告投放种草带货'
        },
        component: resolve => {
          require(['@/pages/a_grassCargo.vue'], resolve)
        }
      },

      //广告投放新闻投放
      {
        path: '/releaseNews',
        name: 'releaseNews',
        meta: {
          title: '广告投放新闻投放'
        },
        component: resolve => {
          require(['@/pages/a_releaseNews.vue'], resolve)
        }
      },

      //广告投放新闻
      {
        path: '/News',
        name: 'News',
        meta: {
          title: '广告投放新闻'
        },
        component: resolve => {
          require(['@/pages/a_News.vue'], resolve)
        }
      },
       //霸屏营销
       {
        path: '/screen_marketing',
        name: 'screen_marketing',
        meta: {
          title: '霸屏营销'
        },
        component: resolve => {
          require(['@/pages/screen_marketing.vue'], resolve)
        }
      },
      {
            path: '/loginMiddleware',
            name: 'loginMiddleware',
            meta: {
                title: '极致了 - 用户登入'
            },
            component: resolve => {
                require(['@/pages/login/loginMiddleware.vue'], resolve)
            }
        },
        {
            path: '/zhongjian',
            name: 'zhongjian',
            meta: {
                title: '极致了-中间页'
            },
            component: resolve => {
                require(['@/pages/login/login.vue'], resolve)
            }

        },
        {
            path: '/register',
            name: 'register',
            meta: {
                title: '极致了 - 用户注册'
            },
            component: resolve => {
                require(['@/pages/login/register.vue'], resolve)
            }
        },
        {
            path: '/customization',
            name: 'customization',
            meta: {
                title: '数据定制'
            },
            component: resolve => {
                require(['@/pages/customization.vue'], resolve)
            }
        },
        {
            path: '/customerCase',
            name: 'customerCase',
            meta: {
                title: '吉利合作方案',
            },
            component: resolve => {
                require(['@/pages/customerCase.vue'], resolve)
            },
        },
        {
            path: '/customcase',
            name: 'customcase',
            meta: {
                title: '客户案例',
            },
            component: resolve => {
                require(['@/pages/customcase.vue'], resolve)
            },
        },
        {
            path: '/newhelpcenter',
            name: 'newhelpcenter',
            meta: {
                title: '帮助中心',
            },
            component: resolve => {
                require(['@/pages/help/newhelpcenter.vue'], resolve)
            },
        },
        {
            path: '/',
            name: 'indexs',
            meta: {
                title: '极致了 - 微信公众号API接口文章素材小程序实时数据查询采集分析工具'
            },
            component: resolve => {
                require(['@/pages/indexs.vue'], resolve)
            }
        },
        {
            path: '/indexs',
            name: 'indexs',
            meta: {
                title: '极致了 - 微信公众号API接口文章素材小程序实时数据查询采集分析工具',
            },
            component: resolve => {
                require(['@/pages/indexs.vue'], resolve)
            }
        },
        {
            path: '/shengming',
            name: 'shengming',
            meta: {
                title: '极致了 - 微信公众号API接口文章素材小程序实时数据查询采集分析工具'
            },
            component: resolve => {
                require(['@/pages/shengming.vue'], resolve)
            }
        },
        {
            path: '/newnotice',
            name: 'newnotice',
            meta: {
                title: '最新公告'
            },
            component: resolve => {
                require(['@/pages/newnotice.vue'], resolve)
            }
        },
        {
            path: '/bianji',
            name: 'bianji',
            meta: {
                title: '编辑最新公告'
            },
            component: resolve => {
                require(['@/pages/bianji.vue'], resolve)
            }
        },
        {
            path: '/shengming1',
            name: 'shengming1',
            meta: {
                title: '极致了 - 微信公众号API接口文章素材小程序实时数据查询采集分析工具'
            },
            component: resolve => {
                require(['@/pages/shengming1.vue'], resolve)
            }
        },
        {
            path: '/succ',
            name: 'succ',
            meta: {
                title: '返回的充值记录'
            },
            component: resolve => {
                require(['@/pages/succ.vue'], resolve)
            }
        },
        {
            path: '/currentVip',
            name: 'currentVip',
            meta: {
                title: '当前会员状态'
            },
            component: resolve => {
                require(['@/pages/currentVip.vue'], resolve)
            }
        },
        {
            path: '/paySuccess',
            name: 'paySuccess',
            meta: {
                title: '订单支付详情'
            },
            component: resolve => {
                require(['@/pages/paySuccess.vue'], resolve)
            }
        },
        {
            path: '/aboutus',
            name: 'aboutus',
            meta: {
                title: '关于我们'
            },
            component: resolve => {
                require(['@/pages/aboutus.vue'], resolve)
            }
        },
        {
            path: '/wordVip',
            name: 'wordVip',
            meta: {
                title: 'API接口'
            },
            component: resolve => {
                components
                require(['@/pages/wordVip.vue'], resolve)
            }
        },
        {
            path: '/historyTwo',
            name: 'historyTwo',
            meta: {
                title: '公众号历史发文列表'
            },
            component: resolve => {
                require(['@/pages/historyTwo.vue'], resolve)
            }
        },
        {
            path: '/historyThree',
            name: 'historyThree',
            meta: {
                title: '公众号历史发文列表'
            },
            component: resolve => {
                require(['@/pages/historyThree.vue'], resolve)
            }
        },
        {
            path: '/phpDemo',
            name: 'phpDemo',
            meta: {
                title: '公众号数据服务平台'
            },
            component: resolve => {
                require(['@/pages/phpDemo.vue'], resolve)
            }
        },
        {
            path: '/pythonDemo',
            name: 'pythonDemo',
            meta: {
                title: '公众号数据服务平台'
            },
            component: resolve => {
                require(['@/pages/pythonDemo.vue'], resolve)
            }
        },
        {
            path: '/cDemo',
            name: 'cDemo',
            meta: {
                title: '公众号数据服务平台'
            },
            component: resolve => {
                require(['@/pages/cDemo.vue'], resolve)
            }
        },
        {
            path: '/javaDemo',
            name: 'javaDemo',
            meta: {
                title: '公众号数据服务平台'
            },
            component: resolve => {
                require(['@/pages/javaDemo.vue'], resolve)
            }
        },
        // {
        //     path: '/customized',
        //     name: 'customized',
        //     meta: {
        //         title: '数据定制'
        //     },
        //     component: resolve => {
        //         require(['@/pages/customized.vue'], resolve)
        //     }
        // },
        // {
        //     path: '/caseDetail',
        //     name: 'caseDetail',
        //     meta: {
        //         title: '客户案例'
        //     },
        //     component: resolve => {
        //         require(['@/pages/caseDetail.vue'], resolve)
        //     }
        // },
        {
            path: '/stopingDetail',
            name: 'stopingDetail',
            meta: {
                title: '回采详情'
            },
            component: resolve => {
                require(['@/pages/stopingDetail.vue'], resolve)
            }
        },
        {
            path: '/wxregest',
            name: 'wxregest',
            meta: {
                title: '极致了-微信注册'
            },
            component: resolve => {
                require(['@/pages/wxregest.vue'], resolve)
            }
        },
        // ---------------------------------
        // {
        //     path: '/datastoping',
        //     name: 'datastoping',
        //     meta: {
        //         title: '回采弹窗'
        //     },
        //     component: resolve => {
        //         require(['@/pages/datastoping.vue'], resolve)
        //     },
        // },
        // {
        //     path: '/datamonitor',
        //     name: 'datamonitor',
        //     meta: {
        //         title: '回采弹窗'
        //     },
        //     component: resolve => {
        //         require(['@/pages/datamonitor.vue'], resolve)
        //     },
        // },
        // {
        //     path: '/datadetails',
        //     name: 'datadetails',
        //     meta: {
        //         title: '原文应用详情'
        //     },
        //     component: resolve => {
        //         require(['@/pages/datadetails.vue'], resolve)
        //     },
        // },
        // {
        //     path: '/aboutwe',
        //     name: 'aboutwe',
        //     meta: {
        //         title: '关于我们'
        //     },
        //     component: resolve => {
        //         require(['@/pages/aboutwe.vue'], resolve)
        //     }
        // },
        {
            path: '/userguide',
            name: 'userguide',
            meta: {
                title: '极致了助手使用指南'
            },
            component: resolve => {
                require(['@/pages/help/userguide.vue'], resolve)
            }
        },
        // 创始人介绍
        {
            path: '/founderIntroduction',
            name: 'founderIntroduction',
            meta: {
                title: '极致了—华媒会2022年会员招募介绍'
            },
            component: resolve => {
                require(['@/pages/founder/founder_introduction.vue'], resolve)
            }
        },
        {
            path: '/binding',
            name: 'binding',
            meta: {
                title: '突破公众号运营者绑定'
            },
            component: resolve => {
                require(['@/pages/binding.vue'], resolve)
            }
        },
        {
            path: '/transfer',
            name: 'transfer',
            meta: {
                title: '流量主突破'
            },
            component: resolve => {
                require(['@/pages/transfer.vue'], resolve)
            }
        },
        {
            path: '/apptp',
            name: 'apptp',
            meta: {
                title: '公众号突破注册'
            },
            component: resolve => {
                require(['@/pages/apptp.vue'], resolve)
            }
        },
        {
            path: '/automatic',
            name: 'automatic',
            meta: {
                title: '自动登录'
            },
            component: resolve => {
                require(['@/pages/automatic.vue'], resolve)
            }
        },
        {
            path: '/appsli',
            name: 'appsli',
            meta: {
                title: '极致了 - 公众号低价推文'
            },
            component: resolve => {
                require(['@/pages/officialAccountTweet/appsli.vue'], resolve)
            }
        },
        {
            path: '/officialflow',
            name: 'officialflow',
            meta: {
                title: '公众号关注说明'
            },
            component: resolve => {
                require(['@/pages/officialAccountTweet/officialflow.vue'], resolve)
            }
        },
        {
            path: '/xlhz',
            name: 'xlhz',
            meta: {
                title: '销量魔盒'
            },
            component: resolve => {
                require(['@/pages/officialAccountTweet/xlhz.vue'], resolve)
            }
        },
        //推文
        {
            path: '/tweet',
            name: 'tweet',
            meta: {
                title: '极致了 - 公众号低价推文'
            },
            component: resolve => {
                require(['@/pages/officialAccountTweet/tweet.vue'], resolve)
            }
        },
        {
            path: '/gzhTransfer',
            name: 'gzhTransfer',
            meta: {
                title: '公众号迁移'
            },
            component: resolve => {
                require(['@/pages/gzhTransfer.vue'], resolve)
            }
        },
        {
            path: '/oanav',
            name: 'oanav',
            meta: {
                title: '公众号导航'
            },
            component: resolve => {
                require(['@/pages/oanav.vue'], resolve)
            }
        },
        {
            path: '/deletion',
            name: 'deletion',
            meta: {
                title: '公众号文章处理'
            },
            component: resolve => {
                require(['@/pages/deletion.vue'], resolve)
            }
        },
        {
            path: '/opening',
            name: 'opening',
            meta: {
                title: '评论开通'
            },
            component: resolve => {
                require(['@/pages/opening.vue'], resolve)
            }
        },
        {
            path: '/appsearch',
            name: 'appsearch',
            meta: {
                title: '搜索'
            },
            component: resolve => {
                require(['@/pages/appsearch.vue'], resolve)
            },
            children: [{
                    // 小程序搜索
                    path: "/",
                    redirect: "/searchild",
                },
                {
                    path: '/searchild',
                    name: 'searchild',
                    meta: {
                        title: '小程序搜索'
                    },
                    component: resolve => {
                        require(['@/pages/searchild.vue'], resolve)
                    },
                },
                {
                    path: '/programTop',
                    name: 'programTop',
                    meta: {
                        title: '小程序榜单',
                    },
                    component: resolve => {
                        require(['@/pages/programTop.vue'], resolve)
                    },
                },
                {
                    path: '/appdetail',
                    name: 'appdetail',
                    meta: {
                        title: '小程序详情',
                    },
                    component: resolve => {
                        require(['@/pages/appdetail.vue'], resolve)
                    },
                },
                {
                    path: '/officialAccount',
                    name: 'officialAccount',
                    meta: {
                        title: '公众号关注',
                    },
                    component: resolve => {
                        require(['@/pages/myAttention/officialAccount.vue'], resolve)
                    },
                },
                {
                    path: '/subscribe',
                    name: 'subscribe',
                    meta: {
                        title: '关键词订阅',
                    },
                    component: resolve => {
                        require(['@/pages/myAttention/subscribe.vue'], resolve)
                    },
                },
                {
                    path: '/sogoHerf',
                    name: 'sogoHerf',
                    meta: {
                        title: '搜狗临时链接转永久链接'
                    },
                    component: resolve => {
                        require(['@/pages/sogoHerf.vue'], resolve)
                    }
                },
                {
                    path: '/sogopro',
                    name: 'sogopro',
                    meta: {
                        title: '搜狗临时链接转永久链接Pro'
                    },
                    component: resolve => {
                        require(['@/pages/sogopro.vue'], resolve)
                    }
                },
                {
                    path: '/APIAssemble',
                    name: 'APIAssemble',
                    meta: {
                        title: 'API集结'
                    },
                    component: resolve => {
                        require(['@/pages/APIAssemble.vue'], resolve)
                    }
                },
                {
                    path: '/getHtml',
                    name: 'getHtml',
                    meta: {
                        title: '获取文章正文（html）'
                    },
                    component: resolve => {
                        require(['@/pages/getHtml.vue'], resolve)
                    }
                },
                {
                    path: '/langchinge',
                    name: 'getHlangchinge',
                    meta: {
                        title: '长链接转短链接'
                    },
                    component: resolve => {
                        require(['@/pages/langchinge.vue'], resolve)
                    }
                },
                {
                    path: '/articleCollection',
                    name: 'articleCollection',
                    meta: {
                        title: '文章收藏',
                    },
                    component: resolve => {
                        require(['@/pages/myAttention/articleCollection.vue'], resolve)
                    },
                },
                {
                    path: '/index',
                    name: 'index',
                    meta: {
                        title: '公众号搜索'
                    },
                    component: resolve => {
                        require(['@/pages/index.vue'], resolve)
                    }
                },
                {
                    path: '/articleSearch',
                    name: 'articleSearch',
                    meta: {
                        title: '文章搜索'
                    },
                    component: resolve => {
                        require(['@/pages/articleSearch.vue'], resolve)
                    }
                },
                {
                    path: '/center',
                    name: 'center',
                    meta: {
                        title: '会员中心'
                    },
                    component: resolve => {
                        require(['@/pages/center.vue'], resolve)
                    }
                },
                {
                    path: '/interface',
                    name: 'interface',
                    meta: {
                        title: 'API接口调用'
                    },
                    component: resolve => {
                        require(['@/pages/interface.vue'], resolve)
                    }
                },
                {
                    path: '/burst',
                    name: 'burst',
                    meta: {
                        title: '爆文中心'
                    },
                    component: resolve => {
                        require(['@/pages/burst.vue'], resolve)
                    }
                },
                {
                    path: '/hottext',
                    name: 'hottext',
                    meta: {
                        title: '今日热文'
                    },
                    component: resolve => {
                        require(['@/pages/hottext.vue'], resolve)
                    }
                },
                {
                    path: '/monitor',
                    name: 'monitor',
                    meta: {
                        title: '分钟级监控(旧)'
                    },
                    component: resolve => {
                        require(['@/pages/monitor.vue'], resolve)
                    }
                },
                {
                    path: '/monitorNew',
                    name: 'monitorNew',
                    meta: {
                        title: '分钟级监控(新)'
                    },
                    component: resolve => {
                        require(['@/pages/monitorNew.vue'], resolve)
                    }
                },
                {
                    path: '/monitorView',
                    name: 'monitorView',
                    meta: {
                        title: '监控报告'
                    },
                    component: resolve => {
                        require(['@/pages/monitorView.vue'], resolve)
                    }
                },
                {
                    path: '/monitorViewNew',
                    name: 'monitorViewNew',
                    meta: {
                        title: '监控报告(新)'
                    },
                    component: resolve => {
                        require(['@/pages/monitorViewNew.vue'], resolve)
                    }
                },

                {
                    path: '/stoping',
                    name: 'stoping',
                    meta: {
                        title: '数据回采'
                    },
                    component: resolve => {
                        require(['@/pages/stoping.vue'], resolve)
                    }
                },
                {
                    path: '/detail',
                    name: 'detail',
                    meta: {
                        title: '公众号详情'
                    },
                    component: resolve => {
                        require(['@/pages/detail.vue'], resolve)
                    }
                },
                {
                    path: '/similar',
                    name: 'similar',
                    meta: {
                        title: '相似公众号'
                    },
                    component: resolve => {
                        require(['@/pages/similar.vue'], resolve)
                    }
                },
                {
                    path: '/withSubject',
                    name: 'withSubject',
                    meta: {
                        title: '公众号主体信息'
                    },
                    component: resolve => {
                        require(['@/pages/withSubject.vue'], resolve)
                    }
                },
                {
                    path: '/monitors',
                    name: 'monitors',
                    meta: {
                        title: '数据监测报告列表'
                    },
                    component: resolve => {
                        require(['@/pages/monitors.vue'], resolve)
                    }
                },

                {
                    path: '/ment',
                    name: 'ment',
                    meta: {
                        title: '舆情'
                    },
                    component: resolve => {
                        require(['@/pages/publicSentiment/index.vue'], resolve)
                    }
                },
                {
                    path: '/accountList',
                    name: 'accountList',
                    meta: {
                        title: '公众号榜单(新)'
                    },
                    component: resolve => {
                        require(['@/pages/accountList.vue'], resolve)
                    }
                },
                {
                    path: '/applicatio',
                    name: 'applicatio',
                    meta: {
                        title: '原文应用榜单'
                    },
                    component: resolve => {
                        require(['@/pages/applicatio.vue'], resolve)
                    }
                },
                {
                    path: '/trueNumber',
                    name: 'trueNumber',
                    meta: {
                        title: '真号榜单(新)'
                    },
                    component: resolve => {
                        require(['@/pages/public/trueNumber.vue'], resolve)
                    }
                },
              {
                path: '/trueNumberOld',
                name: 'trueNumberOld',
                meta: {
                  title: '真号榜单(旧)'
                },
                component: resolve => {
                  require(['@/pages/public/trueNumberOld.vue'], resolve)
                }
              },
              {
                path: '/fakeNumberOld',
                name: 'fakeNumberOld',
                meta: {
                  title: '假号榜单(旧)'
                },
                component: resolve => {
                  require(['@/pages/public/fakeNumberOld.vue'], resolve)
                }
              },
                {
                    path: '/details',
                    name: 'details',
                    meta: {
                        title: '原文应用详情'
                    },
                    component: resolve => {
                        require(['@/pages/details.vue'], resolve)
                    }
                },
                {
                    path: '/singleDay',
                    name: 'singleDay',
                    meta: {
                        title: '公众号当天发文情况'
                    },
                    component: resolve => {
                        require(['@/pages/singleDay.vue'], resolve)
                    }
                },
                {
                    path: '/history',
                    name: 'history',
                    meta: {
                        title: '公众号历史发文列表'
                    },
                    component: resolve => {
                        require(['@/pages/history.vue'], resolve)
                    }
                },
                {
                    path: '/read',
                    name: 'read',
                    meta: {
                        title: '文章阅读与点赞'
                    },
                    component: resolve => {
                        require(['@/pages/read.vue'], resolve)
                    }
                },
                {
                    path: '/innet',
                    name: 'innet',
                    meta: {
                        title: '文章阅读与点赞在线调试'
                    },
                    component: resolve => {
                        require(['@/pages/innet.vue'], resolve)
                    }
                },
                {
                    path: '/articleContent',
                    name: 'articleContent',
                    meta: {
                        title: '文章信息'
                    },
                    component: resolve => {
                        require(['@/pages/articleContent.vue'], resolve)
                    }
                },
                {
                    path: '/subject',
                    name: 'subject',
                    meta: {
                        title: '公众号主体信息'
                    },
                    component: resolve => {
                        require(['@/pages/subject.vue'], resolve)
                    }
                },
                {
                    path: '/wxarticle',
                    name: 'wxarticle',
                    meta: {
                        title: '根据关键词获取微信文章API'
                    },
                    component: resolve => {
                        require(['@/pages/wxarticle.vue'], resolve)
                    }
                },
                {
                    path: '/comment',
                    name: 'comment',
                    meta: {
                        title: '文章评论'
                    },
                    component: resolve => {
                        require(['@/pages/comment.vue'], resolve)
                    }
                },
                {
                    path: '/getheard',
                    name: 'getheard',
                    meta: {
                        title: '获取公众号头像和类型'
                    },
                    component: resolve => {
                        require(['@/pages/getheard.vue'], resolve)
                    }
                },
                {
                  path: '/insidesearch',
                    name: 'insidesearch',
                    meta: {
                        title: '获取指定公众号内含有关键字标题的文章'
                    },
                    component: resolve => {
                        require(['@/pages/insidesearch.vue'], resolve)
                    }
                },
              {
                path: '/Keyverifycode',
                name: 'Keyverifycode',
                meta: {
                  title: '获取公众号头像和类型'
                },
                component: resolve => {
                  require(['@/pages/Keyverifycode.vue'], resolve)
                }
              },
                {
                    path: '/wordDetail',
                    name: 'wordDetail',
                    meta: {
                        title: '文章详情'
                    },
                    component: resolve => {
                        require(['@/pages/wordDetail.vue'], resolve)
                    }
                },
                {
                    path: '/longHerf',
                    name: 'longHerf',
                    meta: {
                        title: '公众号数据服务平台'
                    },
                    component: resolve => {
                        require(['@/pages/longHerf.vue'], resolve)
                    }
                },
                {
                    path: '/word',
                    name: 'word',
                    meta: {
                        title: '接口调用说明'
                    },
                    component: resolve => {
                        require(['@/pages/word.vue'], resolve)
                    }
                },
                // {
                //     path: '/apptp',
                //     name: 'apptp',
                //     meta: {
                //         title: '公众号突破注册'
                //     },
                //     component: resolve => {
                //         require(['@/pages/apptp.vue'], resolve)
                //     }
                // },
                {
                    path: '/binding',
                    name: 'binding',
                    meta: {
                        title: '突破公众号运营者绑定'
                    },
                    component: resolve => {
                        require(['@/pages/binding.vue'], resolve)
                    }
                },
                {
                    path: '/collection',
                    name: 'collection',
                    meta: {
                        title: '我的收藏'
                    },
                    component: resolve => {
                        require(['@/pages/collection.vue'], resolve)
                    }
                },
                {
                    path: '/getinvoice',
                    name: 'getinvoice',
                    meta: {
                        title: '申请发票'
                    },
                    component: resolve => {
                        require(['@/pages/centerModular/getinvoice.vue'], resolve)
                    }
                },
                {
                    path: '/bodysearch',
                    name: 'bodysearch',
                    meta: {
                        title: '同主体公众号搜索'
                    },
                    component: resolve => {
                        require(['@/pages/bodysearch.vue'], resolve)
                    }
                },
                {
                    path: '/articlepro',
                    name: 'articlepro',
                    meta: {
                        title: '获取文章详情Pro'
                    },
                    component: resolve => {
                        require(['@/pages/articlepro.vue'], resolve)
                    },
                },
                {
                    path: '/offcontrast',
                    name: 'offcontrast',
                    meta: {
                        title: '公众号对比'
                    },
                    component: resolve => {
                        require(['@/pages/offcontrast.vue'], resolve)
                    },
                },
                {
                    path: '/companylist',
                    name: 'companylist',
                    meta: {
                        title: '公众号主体公司榜单'
                    },
                    component: resolve => {
                        require(['@/pages/companylist.vue'], resolve)
                    },
                },
                {
                    path: '/brandvolumelist',
                    name: 'brandvolumelist',
                    meta: {
                        title: '品牌声量榜单'
                    },
                    component: resolve => {
                        require(['@/pages/brandvolumelist.vue'], resolve)
                    },
                },
                {
                    path: '/advertisingtraffic',
                    name: 'advertisingtraffic',
                    meta: {
                        title: '广告流量大盘'
                    },
                    component: resolve => {
                        require(['@/pages/advertisingtraffic.vue'], resolve)
                    },
                },
            ]
        }
    ],
});
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});
// 百度统计
// router.beforeEach((to, from, next) => {
//     if (window._hmt) {
//     if (to.path) {
//         window._hmt.push(['_trackPageview', '/#' + to.fullPath])
//     }
//     }
//     next()
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js